import image1 from "./image1.jpg";
import image2 from "./image2.jpg";
import image3 from "./image3.jpg";
import styles from "./ProductImages.css";

const images = [{ src: image1 }, { src: image2 }, { src: image3 }];

const ProductImages = () => (
  <ul className={styles.images}>
    {images.map((image, id) => (
      <li className={styles.imageContainer} key={`${image.src}-${id}`}>
        <img alt="" src={image.src} className={styles.image} />
        <div className={styles.padlock}></div>
      </li>
    ))}
  </ul>
);

export default ProductImages;
